import { render, staticRenderFns } from "./input-old.vue?vue&type=template&id=471283ca&scoped=true&"
import script from "./input-old.vue?vue&type=script&lang=js&"
export * from "./input-old.vue?vue&type=script&lang=js&"
import style0 from "./input-old.vue?vue&type=style&index=0&id=471283ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471283ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471283ca')) {
      api.createRecord('471283ca', component.options)
    } else {
      api.reload('471283ca', component.options)
    }
    module.hot.accept("./input-old.vue?vue&type=template&id=471283ca&scoped=true&", function () {
      api.rerender('471283ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/input-old.vue"
export default component.exports